/**
 * QPM(성능 모니터링) 전체 스위치.
 *
 * QPM 은 브라우저에서 성능·트레이스 데이터를 모아 별도 서버(기본 :3006)로 보낸다.
 * 지금은 그 서버를 운영하지 않기로 해서 기능 전체를 꺼 둔다.
 *
 * 이 값 하나가 다음을 모두 막는다:
 *   - RUM 수집과 전송        (utils/rum.js — initRUM, setRUMEnabled)
 *   - API 호출 트레이스       (services/BaseService.js 인터셉터)
 *   - 헤더의 트레이스 토글 버튼 (main/ModernLayout.js)
 *
 * **토글 버튼으로도 켤 수 없다.** 껐다는 말이 화면 어딘가에서 뒤집히면 껐다고 할 수 없다.
 *
 * 다시 켤 때는 이 값을 true 로 바꾸고, QPM 서버(REACT_APP_QPM_ENDPOINT)가 실제로
 * 떠 있는지부터 확인할 것. 서버가 없으면 요청이 매번 실패하며 콘솔을 채운다.
 */
export const QPM_ENABLED = false;

export default QPM_ENABLED;
